module.exports = __webpack_public_path__ + "static/img/active4.89d68461.png";